// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(12),
    requestId: z.string().min(1).max(128),
    payloadHash: z.string().min(1).max(64),
    primaryEmail: z.string().min(1).max(128),
    googleUnlinked: z.boolean(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(12),
    requestId: z.string().min(1).max(128),
    payloadHash: z.string().min(1).max(64),
    primaryEmail: z.string().min(1).max(128),
    googleUnlinked: z.boolean(),
    createdAt: z.number(),
});
export const UserEmailChanges = Object.freeze({
    table: 'user_email_changes',
    tableSingular: 'user_email_change',
    fields: {
        tenantId: 'tenant_id',
        userId: 'user_id',
        requestId: 'request_id',
        payloadHash: 'payload_hash',
        primaryEmail: 'primary_email',
        googleUnlinked: 'google_unlinked',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'userId',
        'requestId',
        'payloadHash',
        'primaryEmail',
        'googleUnlinked',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
